import { combineReducers } from '@reduxjs/toolkit';
import windows from '../../windows/redux/windowsSlice';
import sections from '../../sections/redux/sectionsSlice';
import auth from './auth/authSlice';
import clipboard from './clipboard/clipboardSlice';
import sheetsManager from '../../sheet/redux/sheetsManagerSlice';

export default combineReducers({
  windows,
  sections,
  auth,
  clipboard,
  sheetsManager,
});
